import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';
import DashboardWidgetsWrapper from 'components/Dashboard/WidgetWrapper';
import { GreenPlatesWidgetsEnum } from './utils';
import { memo } from 'react';
import { WidgetConfig } from 'components/Dashboard/types';
import MissingGreenPlatesWidget from './widgets/MissingGreenPlatesWidget';
import GreenPlatesListWidget from './widgets/GreenPlatesListWidget';

const widgetConfigGreenPlates: WidgetConfig<GreenPlatesWidgetsEnum>[] = [
  {
    widgetType: GreenPlatesWidgetsEnum.MissingGreenPlates,
    component: memo(MissingGreenPlatesWidget),
  },
  {
    widgetType: GreenPlatesWidgetsEnum.GreenPlatesList,
    component: memo(GreenPlatesListWidget),
  },
];

const GreenPlatesDashboard = () => {
  const {
    dashboardState: { widgets },
  } = useDashboardControls();

  const getIsActive = (widgetType: GreenPlatesWidgetsEnum) => {
    return widgets.some(
      (w) => w.identifier === widgetType && w.active === true
    );
  };

  return (
    <DashboardWidgetsWrapper>
      {widgetConfigGreenPlates.map(
        ({ widgetType, component: Component }) =>
          getIsActive(widgetType) && <Component key={widgetType} />
      )}
    </DashboardWidgetsWrapper>
  );
};

export default GreenPlatesDashboard;
